<div class="row no-gutter layout-header topClass">
  <div class="col-md-5 col-sm-12 d-flex">
    <h6 class="head">Change log</h6>
  </div>
  <div class="col-md-6 col-sm-12 d-flex align-items-center justify-content-sm-start justify-content-md-end right-header">
    @if (canManage) {
      <button class="create-action"
        routerLink="/privacy-setting/prepare-logs">
        <span>Add Logs </span>
      </button>
    }

    <mat-form-field class="date-picker">
      <mat-date-range-input [rangePicker]="picker">
        <input matStartDate placeholder="Start date" [(ngModel)]="startDates" (dateChange)="startDateChange($event)" />
        <input matEndDate placeholder="End date" [(ngModel)]="endDates" (dateChange)="endDateChange($event)" />
      </mat-date-range-input>
      <mat-datepicker-toggle matIconSuffix [for]="picker">
      </mat-datepicker-toggle>
      <mat-date-range-picker #picker></mat-date-range-picker>
    </mat-form-field>
  </div>
</div>

<div class="main">
  <div class="page-title">
    <h4>Change Logs</h4>
    @if (versions.length > 0) {
      <span class="release-count">{{ versions.length }} {{ versions.length === 1 ? "release" : "releases" }}</span>
    }
  </div>

  @if (versions.length > 0) {
    <div class="mainContent">
      <nav class="release-list" aria-label="Releases">
        @for (version of versions; track version.id) {
          <div class="release" role="button" tabindex="0" [class.active]="current === version"
            [attr.aria-current]="current === version ? 'true' : null"
            (click)="clicked(version.version)" (keydown.enter)="clicked(version.version)">
            <div class="release-info">
              <span class="release-version">{{ version.version }}</span>
              <span class="release-date">{{ version.createdAt }}</span>
            </div>
            @if (canManage) {
              <div class="release-actions">
                <button type="button" class="icon-btn" title="Edit" aria-label="Edit release"
                  (click)="$event.stopPropagation(); confirmEdit(version)">
                  <img src="assets/images/edit-icon.svg" alt="" />
                </button>
                <button type="button" class="icon-btn danger" title="Delete" aria-label="Delete release"
                  (click)="$event.stopPropagation(); confirmDeletion(version)">
                  <img src="assets/images/trash-can.svg" alt="" />
                </button>
              </div>
            }
          </div>
        }
      </nav>

      <section class="release-detail">
        <header class="release-header">
          <div class="release-title">
            <div class="title-row">
              <h3>BAS {{ current?.version }}</h3>
              @if (current === versions[0]) {
                <span class="tag-latest">Latest</span>
              }
            </div>
            <span class="release-sub">Released {{ current?.createdAt }}</span>
          </div>
          <div class="author">
            <span class="avatar">{{ authorInitial }}</span>
            <div class="author-text">
              <span class="author-name">{{ authorName }}</span>
              <span class="author-date">Updated {{ current?.updatedAt }}</span>
            </div>
          </div>
        </header>
        <article class="mycontent" [innerHTML]="getTrustedHTML(current?.updates)"></article>
      </section>
    </div>
  } @else {
    <div class="noLog">
      <span class="material-icons">history</span>
      <p>No change logs for the selected dates</p>
    </div>
  }
</div>
